import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { useGlossary } from "src/hooks/useGlossary";
import { SchoolFormId } from "../types";
import { MultiSchoolWarningDialog } from "./MultiSchoolWarningDialog";
import { RunMatchDialog } from "./RunMatchDialog";

interface RunMatchButtonProps {
  formTemplateId: string;
  selectedFormSchools: SchoolFormId[];
}

export const RunMatch: React.FC<RunMatchButtonProps> = ({
  formTemplateId,
  selectedFormSchools,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [matchName, setMatchName] = useState("");
  const { glossary } = useGlossary();
  const [showMultiSchoolWarning, setShowMultiSchoolWarning] = useState(false);

  const hasMultipleSchools = useMemo(() => {
    const uniqueSchools = new Set(
      selectedFormSchools
        .map((sf) => sf.schoolId)
        .filter((id): id is string => !!id)
    );
    return uniqueSchools.size > 1;
  }, [selectedFormSchools]);

  const handleRunMatchClick = () => {
    if (hasMultipleSchools) {
      setShowMultiSchoolWarning(true);
    } else {
      onOpen();
    }
  };

  const handleConfirmMultiSchool = () => {
    setShowMultiSchoolWarning(false);
    onOpen();
  };

  return (
    <>
      <MenuItem
        textColor="gray.700"
        fontWeight="400"
        fontSize="sm"
        onClick={handleRunMatchClick}
        isDisabled={!selectedFormSchools.length}
      >
        {glossary`Run match`}
      </MenuItem>

      <MultiSchoolWarningDialog
        isOpen={showMultiSchoolWarning}
        onClose={() => setShowMultiSchoolWarning(false)}
        onConfirm={handleConfirmMultiSchool}
      />

      <RunMatchDialog
        formTemplateId={formTemplateId}
        schoolForms={selectedFormSchools}
        isOpen={isOpen}
        onCancel={onClose}
        matchName={matchName}
        onMatchNameChange={setMatchName}
      />
    </>
  );
};
